import * as actionTypes from './actionTypes';
import * as actions from './index';

export const youtubeAddLogin = () => {
    return dispatch => {
		dispatch({ type: actionTypes.YOUTUBE_LOGIN_LIST_START });
        window.flow.youtubeAddLogin().then(res => {
			console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_LOGIN_DELETE_SUCCESS, logins: res.logins});
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_LOGIN_DELETE_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeDeleteLogin = (email) => {
    return dispatch => {
		dispatch({ type: actionTypes.YOUTUBE_LOGIN_LIST_START });
        window.flow.youtubeDelLogin(email).then(res => {
			console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_LOGIN_ADD_SUCCESS, logins: res.logins});
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_LOGIN_ADD_FAIL});
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeGetLogins = () => {
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_LOGIN_LIST_START });
        window.flow.youtubeGetLogins().then(res => {
			console.log("----",res);
            dispatch({ type: actionTypes.YOUTUBE_LOGIN_LIST_SUCCESS, logins: res.logins});
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_LOGIN_LIST_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

/*
 * NOTE:
 * To get managed channels - remove {mine:true} and set {managed: true}
 * Call this func twice with the different parameter to get all channels
 */
export const youtubeGetChannels = (email) => {
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_CHANNEL_LIST_START });
        window.flow.youtubeChannelsList(email,{ part: 'id,status,snippet,contentDetails,statistics', mine: true, maxResults: 20 }).then(res => {
    console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_CHANNEL_LIST_SUCCESS, result: res.result});
            dispatch(actions.youtubeGetPlaylists(email));
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_CHANNEL_LIST_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeGetVideos = (email) => {
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_VIDEO_LIST_START });
        window.flow.youtubeSearchList(email,{ part: 'snippet', type: ['video'], forMine: true, maxResults: 50 }).then(res => {
    console.log(res);
            //dispatch({ type: actionTypes.YOUTUBE_VIDEO_LIST_SUCCESS, result: res.result});
            
            const ids = res.result.items.map(item => {
                return item.id.videoId;
            });
            
            console.log(ids);
            dispatch(actions.youtubeGetCompleteVideos(email, ids.join(',')));
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_VIDEO_LIST_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeGetCompleteVideos = (email,ids) => {
    console.log(ids);
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_VIDEO_GET_START });
        window.flow.youtubeVideosList(email, { 
            part: [ "snippet,id,status" ],
            id: [ ids ]
        }).then(res => {
    console.log(res);
            //dispatch({ type: actionTypes.YOUTUBE_VIDEO_GET_SUCCESS, result: res.result});
            dispatch({ type: actionTypes.YOUTUBE_VIDEO_LIST_SUCCESS, result: res.result});
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_VIDEO_GET_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeDeleteVideo = (email,id) => {
    console.log(id);
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_VIDEO_DELETE_START });
        window.flow.youtubeVideosDelete(email, { id: id }).then(res => {
    console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_VIDEO_DELETE_SUCCESS });
            dispatch(actions.youtubeGetVideos(email));
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_VIDEO_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeVideoChangePrivacy = (email, id, privacy) => {
    
    const params = {
        part: ["status"],
        resource: {
            id: id,
            /*"snippet": {
                "categoryId": 22,
                "defaultLanguage": "en",
                "description": "This description is in English.",
                "tags": [
                "new tags"
                ],
                "title": "There is nothing to see here."
            },*/
            status: {
                privacyStatus: privacy
            },
            /*"localizations": {
                "es": {
                "title": "no hay nada a ver aqui",
                "description": "Esta descripcion es en español."
                }
            }*/
        }
        
    }
    
    console.log(id, params);
    
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_VIDEO_UPDATE_START });
        window.flow.youtubeVideosUpdate(email, params).then(res => {
    console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_VIDEO_UPDATE_SUCCESS });
            dispatch(actions.youtubeGetVideos(email));
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_VIDEO_UPDATE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeUpdateVideo = (email, id, params) => {
    
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_VIDEO_DELETE_START });
        window.flow.youtubeVideosDelete(email, { id: id }).then(res => {
    console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_VIDEO_DELETE_SUCCESS });
            dispatch(actions.youtubeGetVideos(email));
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_VIDEO_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

const initUploadStatus = (dispatch, id, params) => {
    const message = {
        operation: "YOUTUBE VIDEO UPLOAD",
        channel: id,
        ...params
    };

    dispatch({ type: actionTypes.STATUSBAR_SET_MESSAGE, message: message });
}

export const youtubeUploadVideo = (email, channel, params) => {
    return dispatch => {
		console.log("youtubeVideosInsert", email, params);
		initUploadStatus(dispatch, channel, params);
        dispatch({ type: actionTypes.YOUTUBE_VIDEO_UPLOAD_START });
        window.flow.youtubeVideosInsert(email, {
			media: params.path, 
			resource:{
				snippet: { title: params.title, description: params.description }, 
				status: { privacyStatus: "private" }
			}
		}).then(res => {
			console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_VIDEO_UPLOAD_SUCCESS });
			dispatch({ type: actionTypes.STATUSBAR_RESET_MESSAGE });
        }).catch(res => {
            console.log(res);
			dispatch({ type: actionTypes.YOUTUBE_VIDEO_UPLOAD_FAIL });
            dispatch(actions.applicationError(res.message));
			dispatch({ type: actionTypes.STATUSBAR_RESET_MESSAGE });
        });
    };
};

/* PLAYLIST FUNCTIONS */
/*******************************************/

export const youtubeGetPlaylists = (email, id = "") => {
    return dispatch => {
        const options = { part: 'id,status,snippet,contentDetails'/*, mine: true/*, maxResults: 20*/ };
        
        if(id) {
            options.id = id;
        } else {
            options.mine = true;
        }
        
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_LIST_START });
        window.flow.youtubePlaylistsList(email, options).then(res => {
            console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_LIST_SUCCESS, result: res.result, reset: (id && true) || false });
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_LIST_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeCreatePlaylist = (email, title) => {
    return dispatch => {
        console.log(email, title);
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_CREATE_START });
        window.flow.youtubePlaylistsInsert(email, {
            part: [ "snippet,status" ],
            resource: {
                snippet: {
                    title: title//,
                    //"description": "This is a sample playlist description.",
                    /*"tags": [
                        "sample playlist",
                        "API call"
                    ],*/
                    //"defaultLanguage": "en"
                },
                status: { privacyStatus: "private" }
            }
        }).then(res => {
			console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_CREATE_SUCCESS });
            dispatch(actions.youtubeGetPlaylists(email));
        }).catch(res => {
            console.log(res);
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_CREATE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeDeletePlaylist = (email, id) => {
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_DELETE_START });
        window.flow.youtubePlaylistsDelete(email, { id: id }).then(res => {
            console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_DELETE_SUCCESS });
            dispatch(actions.youtubeGetPlaylists(email));
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubePlaylistChangePrivacy = (email, id, params) => {
    
    const options = {
        part: "status,snippet",
        resource: {
            id: id,
            snippet: {
                title: params.title,
                description: params.description
            },
            status: {
                privacyStatus: params.privacy
            },
        }
    }
    
    console.log(id, options);
    
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_UPDATE_START });
        window.flow.youtubePlaylistsUpdate(email, options).then(res => {
    console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_UPDATE_SUCCESS });
            dispatch(actions.youtubeGetPlaylists(email, id));
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_UPDATE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeGetPlaylistsItems = (email,id) => {
    return dispatch => {
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_LIST_START });
        window.flow.youtubePlaylistsitemsList(email,{ part: 'id,status,snippet,contentDetails', playlistId: id, maxResults: 20 }).then(res => {
            console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_LIST_SUCCESS, result: res.result});
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_LIST_FAIL });
            dispatch(actions.applicationError(res.message));
            console.log(res);
        });
    };
};

export const youtubeAddPlaylistItem = (email, playlist, ids) => {
    return dispatch => {
        const id = ids.pop();
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_ADD_START });
        window.flow.youtubePlaylistsitemsInsert(email, {
            part: 'snippet',
            resource: {
                snippet: {
                    playlistId: playlist,
                    position: 0,
                    resourceId: {
                        kind: "youtube#video",
                        videoId: id
                    }
                }
            } 
        }).then(res => {
			console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_ADD_SUCCESS });
            
            // must call recursive because in a loop does not work by youtube 
            if(ids.length) {
                dispatch(actions.youtubeAddPlaylistItem(email, playlist, ids));
            } else {
                dispatch(actions.youtubeGetPlaylists(email, playlist));
            }
        }).catch(res => {
            console.log(res);
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_ADD_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeOrderPlaylistItems = (email, playlist, ids) => {
    return dispatch => {
        const id = ids.pop();
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_ORDER_START });
        window.flow.youtubePlaylistsitemsUpdate(email, {
            part: 'snippet',
            resource: {
                id: 'YOUR_PLAYLIST_ITEM_ID',
                snippet: {
                    playlistId: "YOUR_PLAYLIST_ID",
                    position: 1,
                    resourceId: {
                        kind: "youtube#video",
                        videoId: "YOUR_VIDEO_ID"
                    }
                }
            }
        }).then(res => {
			console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_ORDER_SUCCESS });
            
            // must call recursive because in a loop does not work by youtube 
            if(ids.length) {
                dispatch(actions.youtubeOrderPlaylistItems(email, playlist, ids));
            } else {
                dispatch(actions.youtubeGetPlaylistsItems(email, playlist));
            }
        }).catch(res => {
            console.log(res);
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_ORDER_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const youtubeDeletePlaylistItems = (email, playlist, ids) => {
    return dispatch => {
        const id = ids.pop();
        dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_DELETE_START });
        window.flow.youtubePlaylistsitemsDelete(email, { id: id }).then(res => {
            console.log(res);
            dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_DELETE_SUCCESS });
            
            // must call recursive because in a loop does not work by youtube 
            if(ids.length) {
                dispatch(actions.youtubeDeletePlaylistItems(email, playlist, ids));
            } else {
                dispatch(actions.youtubeGetPlaylists(email, playlist));
                dispatch(actions.youtubeGetPlaylistsItems(email, playlist));
            }
        }).catch(res => {
			dispatch({ type: actionTypes.YOUTUBE_PLAYLIST_ITEMS_DELETE_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};

